import { FORM_UI_STRINGS } from "src/data"

export const getErrorMessage=(key:keyof typeof FORM_UI_STRINGS,label?:string)=>{
    const errorMessage=FORM_UI_STRINGS[key]
    if(errorMessage.includes("{label}") && label){
        return errorMessage.replace(/{label}/g, label)        
    }
    return errorMessage
}